export const LABOR_COST_CHART_COLORS = [
  "#F7E8FF",
  "#E5F3E8",
  "#FFF3D6",
  "#63D0C1",
  "#B1C6E5",
  "#FFD4A8",
];
